import { Component, Input, OnInit, inject } from "@angular/core";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { GroupStore } from "@app/services/store/group-store";
import { WorkGroup } from "@app/models/rest/work-group";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-groups",
  templateUrl: "./groups.component.html",
  styleUrls: ["./groups.component.css"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class GroupsComponent
  extends BaseDataTablePageDirective<WorkGroup>
  implements OnInit
{
  groupStore: GroupStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input()
  public columns: object[] = [
    {
      field: "groupName",
      text: "Group Name",
      flex: 1,
      editor: true
    },
    {
      type: "action",
      text: "Edit",
      width: 50,
      actions: [
        {
          cls: "fa fa-pencil",
          tooltip: "Edit Resource Group",
          onClick: ({ record }) => {
            console.log(`Editing ${record.name}`);
            console.log(this.router);
            if (isNaN(record.id)) {
              console.log("unsaved");
              this.serverErrorHandler.handleClientError(
                "Save changes before editing this record"
              );
              return;
            }
            this.router.navigate(["setup/resourcing/groups", record.id]).then();
          }
        }
      ]
    }
    // {
    //   field: 'scoreWeight',
    //   text: 'Score Weight',
    //   flex: 1,
    //   editor: true,
    //   type: 'number'
    // }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const groupStore = inject(GroupStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      groupStore,
      store,
      dialog,
      "WorkGroup",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );

    this.groupStore = groupStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.gridStore.autoCommit = false;
    this.gridStore.load({});
  }

  addRow() {
    this.gridStore.insert(0, {
      groupName: ""
    });
  }
}
